import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductService } from "../../shared/services/product.service";
import { Product } from "../../shared/classes/product";
import { IBaseItem, IDeleteBaseItem } from 'src/app/shared/Models/TopCollectionProduct';
import { Observable } from 'rxjs';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { BuyerService } from 'src/app/shared/services/BuyerService';
import { HomeService } from 'src/app/shared/services/home.service';
import { IUser } from 'src/app/shared/Models/IUser';

@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.component.html',
  styleUrls: ['./wishlist.component.scss']
})
export class WishlistComponent implements OnInit {

  public products: Product[] = [];
  wishLists$: Observable<IBaseItem[]>;

  constructor(public productService: ProductService,
    private _router: Router,
    private _toastrService: ToastrService,
    private _buyerService: BuyerService,
    private _formBuilder: FormBuilder,
    private _homeService: HomeService) 
    {
    this.productService.wishlistItems.subscribe(response => this.products = response);
  }

  ngOnInit(): void {
    this.wishLists$ = this._homeService.getWishListItems$;


  }

  async addToCart(product: any) {
    const status = await this.productService.addToCart(product);
    if(status) {
      this._router.navigate(['/shop/cart']);
      this.removeItem(product);
    }
  }

  // removeItem(product: any) {
  //   this.productService.removeWishlistItem(product);
  // }

  public removeItem(product: IBaseItem) {

    var user:IUser = JSON.parse(localStorage.getItem('user'));
    if(!user)
    {
      this._toastrService.info("User no login");
      return;
    }

    var productToDelete:IDeleteBaseItem ={
      barcode: product.barcode,
      tableName: 'WishListItem'
    }

    this._homeService.deleteBaseItemByBaseItemId(product.baseItemId).subscribe({
      next:()=>{
        if(user.isWholeSaleAccount.toString()==="True")
        {
          // location.reload();
        }
      }
    });

    //this.productService.removeCartItem(product);
  }
   

}
